import { render, staticRenderFns } from "./WaringTable.vue?vue&type=template&id=59faa0f5&scoped=true"
import script from "./WaringTable.vue?vue&type=script&lang=js"
export * from "./WaringTable.vue?vue&type=script&lang=js"
import style0 from "./WaringTable.vue?vue&type=style&index=0&id=59faa0f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59faa0f5",
  null
  
)

export default component.exports